module.exports = __webpack_public_path__ + "img/icon_dongle.a08f1563.svg";